import React from 'react'
import moment from 'moment'
import { MapIcon, Icon, TripsIcon, PaperclipIcon, NoteIcon, BackIcon, BriefcaseIcon, VehicleIcon, DotIcon, ForwardIcon, MergeIcon } from '../core/icons'
import { Row, Col, Button, Select, DatePicker, Icon as AIcon, Tag, Tooltip, Popover, Checkbox, Dropdown, InputNumber, Tabs, Input } from 'antd';
import { connect } from 'react-redux'
import { addPlace, renamePlace } from './actions'


import styled from 'styled-components'


const Place = styled.div`
  font-style: italic;
  font-weight: 600;
  cursor: context-menu;
`


const LocationRow = styled(Row)`
  flex-flow: nowrap;
`

const Addr = styled.div`
`
const PlaceOrAddr = styled.div`
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  &:hover { text-decoration: underline; }
`
const Location = ({place, color, time, addr, addPlace, renamePlace})=>
  <LocationRow type="flex">
    <Col>
      <DotIcon color={color} width={40} height={18} style={{
        "width": "25px",
        "height": "16px",
        "margin": `${time?-13:-2}px 0px`
      }}/>
    </Col>
    <Col style={{
      // should be consistent with the <Purpose/> above it
    margin: '0 15px',
    width: (!place)&&'91%'
    }}>
      {time && <div style={{opacity: .5}}>
        {moment(time, 'YYYY-MM-DD HH:mm:ss ZZZ').format("h:mm a")}
      </div>}
      <PlaceOrAddr>
        { place ?
          <Popover
            title={<div><i>{addr}</i> <br/>Auto detected as a <b>Favorite Place</b></div>}
            trigger="click"
            placement="right"
            content={
              <Row type="flex" justify="space-between" style={{paddingTop:8}}>

                <a onClick={addPlace}><AIcon type="plus"/> Set New Place</a>


                <a onClick={renamePlace}><AIcon type="edit"/> Rename</a>
              </Row>

          }>
            <Place>{ place.name }</Place>
          </Popover>
          :
          <Tooltip title="Click to name as a Favorite Place">
            <Addr onClick={addPlace}>{ addr }</Addr>
          </Tooltip>
        }
      </PlaceOrAddr>
    </Col>
  </LocationRow>

const mapStateToProps = (state, ownProps)=>{
  return {
    color: ownProps.from ? '#31B59F' : '#FF5166',
    addr: ownProps.from||ownProps.to,
  }
}

const mapDispatchToProps = (dispatch, ownProps)=>{
  const place = {
    ...ownProps.data,
    addr: ownProps.from||ownProps.to,
    place: ownProps.place,
    place_type: ownProps.from ? 'start' : 'end'
  }

  return {
    addPlace:()=>dispatch(addPlace(place)),
    renamePlace:()=>dispatch(renamePlace({
      ...place,
      shouldRename:true
    })),
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(Location)



// WEBPACK FOOTER //
// ./src/trips/Location.jsx